export { default } from './UserDetail'


// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserDetail/index.js